<p>dialog-report works!</p>
